// NOTE: This component will be deprecated in favour of the new component
// src/apps/Initiative/components/List
// See PR #393

import React from 'react'
import { Carousel, Grid, GridCell, View, useWindowResizeSensor } from 'oio-react'
import PropTypes from 'prop-types'
import DiscussionListItemRow from 'src/apps/Discussions/components/ListItemRow'
import InitiativeListItemTile from 'src/components/Initiative/GenericListItemTile'
import { useInitiativeList } from 'src/graphql/hooks'

const InitiativeListDeprecate = ({ cardFormat, gridColumns, initiativeType }) => {
   const { currentBreakpoint } = useWindowResizeSensor()
   const initiativeListFilter = {
      archived: 'exclude',
      sortBy: 'popularity'
   }

   if (initiativeType) {
      initiativeListFilter.typeIds = [initiativeType.id]
   }

   const isDiscussion = initiativeType?.class === 'discussion'
   const { initiativeList, loading } = useInitiativeList(initiativeListFilter)

   return (
      <View>
         {loading && (
            <div>Loading...</div>
         )}
         {initiativeList.items.length === 0 && (
            <View display="block">
               {initiativeType && `There are currently no ${initiativeType.namePlural} to show`}
               {!initiativeType && 'There is currently no content to show'}
            </View>
         )}
         {!loading && isDiscussion && (
            <View>
               {initiativeList.items.map(initiative => (
                  <DiscussionListItemRow
                     key={initiative.id}
                     addedBy={initiative.addedBy.fullName}
                     archived={initiative.archived}
                     dateLastUpdated={initiative.dateLastUpdated}
                     discussionFormat={initiative.discussionFormat}
                     discussionIsClosed={initiative.discussionStatus.closed}
                     hasUnreadEntries={initiative.thread.hasUnreadEntries}
                     linkTo={`/initiatives/${initiative.slug}`}
                     name={initiative.name}
                     numThreadEntries={initiative.thread.numEntries}
                     numViews={initiative.numViews}
                     pinned={initiative.pinned}
                     privacy={initiative.privacy}
                  />
               ))}
            </View>
         )}
         {!loading && !isDiscussion && cardFormat === 'grid' && (
            <Grid columns={gridColumns} spacing="15px[a-b] 30px[c-f]">
               {initiativeList.items.map((initiative) => {
                  const primaryRole = initiative.roles.find(r => r.type === 'primary')

                  return (
                     <GridCell key={initiative.id}>
                        <InitiativeListItemTile
                           archived={initiative.archived}
                           initiativeClass={initiative.class}
                           coverURL={initiative.coverMedia?.file.thumbnailUrlW480}
                           date={initiative.startDateTimeISO8601}
                           link={`/initiatives/${initiative.slug}`}
                           name={initiative.name}
                           numActiveUsers={primaryRole?.numActiveUsers}
                           primaryRoleName={primaryRole?.name}
                           typeName={initiative.type.nameSingular}
                        />
                     </GridCell>
                  )
               })}
            </Grid>
         )}
         {!loading && !isDiscussion && cardFormat === 'carousel' && (
            <Carousel
               spacing={currentBreakpoint > 'b' ? 30 : 18}
               numSlidesPerPane={gridColumns}>
               {initiativeType.initiatives.map((initiative) => {
                  const primaryRole = initiative.roles.find(r => r.type === 'primary')

                  return (
                     <View key={initiative.id} float="left" width="100%">
                        <InitiativeListItemTile
                           archived={initiative.archived}
                           initiativeClass={initiative.class}
                           coverURL={initiative.coverMedia?.file.thumbnailUrlW480}
                           date={initiative.startDateTimeISO8601}
                           link={`/initiatives/${initiative.slug}`}
                           name={initiative.name}
                           numActiveUsers={primaryRole?.numActiveUsers}
                           primaryRoleName={primaryRole?.name}
                           typeName={initiative.type.nameSingular}
                        />
                     </View>
                  )
               })}
            </Carousel>
         )}
      </View>
   )
}

InitiativeListDeprecate.propTypes = {
   cardFormat: PropTypes.oneOf(['carousel', 'grid']),
   gridColumns: PropTypes.string,
   initiativeType: PropTypes.object
}

InitiativeListDeprecate.defaultProps = {
   cardFormat: 'grid',
   gridColumns: '2[a-b] 3[c] 4[d] 5[e] 6[f]',
   initiativeType: undefined
}

export default InitiativeListDeprecate
